import styled from 'styled-components'

interface GridProps {
  gridHeight?: string
  gridCols?: string
  gridGap?: string
  justifyContent?: string
  justifyItems?: string
  alignItems?: string
  backgroundColor?: string
  padding?: string
  margin?: string
  width?: string
  gridColsMobile?: string
  gridGapMobile?: string
  justifyContentMobile?: string
  cursor?: string
}

export const Grid = styled.div<GridProps>`
  display: grid;
  grid: ${(props) => props.gridHeight || 'auto'} / ${(props) =>
      props.gridCols || 'auto'};
  grid-gap: ${(props) => props.gridGap};
  justify-content: ${(props) => props.justifyContent};
  justify-items: ${(props) => props.justifyItems};
  align-items: ${(props) => props.alignItems};
  word-break: break-word;
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  width: ${(props) => props.width};
  cursor: ${(props) => props.cursor};
  @media screen and (max-width: 1199px) {
    grid: auto / ${(props) => props.gridColsMobile || 'auto'};
    grid-gap: ${(props) => props.gridGapMobile || props.gridGap};
    justify-content: ${(props) => props.justifyContentMobile};
  }
`
